/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ChangeScholarshipFileApprovalStatusResultViewModel } from "../types/ChangeScholarshipFileApprovalStatusResultViewModel.ts";
import { eScholarshipTypeStudentFileApprovalStatusSchema } from "./eScholarshipTypeStudentFileApprovalStatusSchema.ts";

export const changeScholarshipFileApprovalStatusResultViewModelSchema =
  z.object({
    success: z.optional(
      z
        .boolean()
        .describe(
          "Indica se a alteração foi aplicada. Falso quando não existe registro de status para o documento.",
        ),
    ),
    generalStatus: z.optional(
      z
        .lazy(() => eScholarshipTypeStudentFileApprovalStatusSchema)
        .describe(
          "0 = PendingAnswerFromTeam | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
        ),
    ),
    shouldPromptScholarshipInProcess: z.optional(
      z
        .boolean()
        .describe(
          "Indica que a documentação ficou totalmente aprovada e a tela deve oferecer colocar a bolsa em processo. No legado essa decisão abria um modal no JavaScript.",
        ),
    ),
  }) as unknown as ToZod<ChangeScholarshipFileApprovalStatusResultViewModel>;
